import useCustomHook from '@/hooks/useCustomHook';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';
import { useEffect, useCallback, useContext } from 'react';

export default function useConceptOptions({ game, assets }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      currentlyPlayingId: null,
    },
    actions: {
      onUserAnswer: (id) => {
        game.actions.setState({ currentAnswerId: id });
      },
    },
  });

  const audioPlayer = useContext(AudioAutoPlayerContext);

  // Play all options audio when concept changes
  useEffect(() => {
    if (game.state.currentConcept) {
      playAllOptionsAudios();
    }
  }, [game.state.currentConcept]);

  const playAllOptionsAudios = useCallback(async () => {
    game.actions.setState({ playingOptionAudios: true });
    const optionAudios = game.state.currentConcept.answerOptions.map(
      (option) => assets.sounds[option.id] //.audio.src
    );
    for (const audio of optionAudios) {
      actions.setState({
        currentlyPlayingId: audio.id,
        playingOptionAudios: true,
      });
      await audioPlayer.actions.play(audio.audio);
    }
    actions.setState({ currentlyPlayingId: null });
    game.actions.setState({ playingOptionAudios: false });
  }, [game.state.currentConcept]);

  return { state, actions };
}
